export default __webpack_public_path__ + "static/23-bb6acf70e42dec31926ba097b3153d96.png";